import { createCheckout } from './checkout-controller';
import { defineZippyPayCheckoutElement } from './element/zippy-pay-checkout';

export { PaymentSessionClient, attachPayerWithRetry } from './api/client';
export { SessionPoller, isTerminalStatus, phaseFromSession } from './session/poller';
export {
  getCountdownTarget,
  getPayWindowRemainingRatio,
  getSoftIdleHint,
  msUntil,
  shouldShowPayProgress,
} from './session/timing';
export { CheckoutController, createCheckout } from './checkout-controller';
export {
  defineZippyPayCheckoutElement,
  ZippyPayCheckoutElement,
  ELEMENT_TAG,
} from './element/zippy-pay-checkout';
export {
  PAYMENT_ID_PATTERN,
  E164_PHONE_PATTERN,
  EMAIL_PATTERN,
  normalizePaymentId,
  normalizePayerQuery,
  isValidPaymentId,
  isValidPayerQuery,
  paymentIdValidationMessage,
  payerQueryValidationMessage,
  formatAmount,
} from './utils';
export {
  ZIPPY_API_BASE_URLS,
  ZIPPY_API_PATH_PREFIX,
  isZippyEnvironment,
  parseZippyEnvironment,
  resolveApiBaseUrl,
} from './config/environments';
export {
  ANDROID_APP_PACKAGE,
  ANDROID_PLAY_STORE_NATIVE_URL,
  APP_STORE_LINKS,
  IOS_APP_STORE_NATIVE_URL,
  resolveAppStoreOpenUrl,
  resolveAppStoreUrl,
} from './config/app-links';
export type { AppStoreLinks } from './config/app-links';
export {
  buildBindPolicyRequest,
  isCheckoutPolicyBound,
  isCheckoutStartAllowed,
  isFullChooserPolicy,
  resolveAutoStartMethod,
  resolveCheckoutUiOptions,
  resolveCheckoutUiOptionsFromBound,
  resolveCheckoutUiOptionsFromSession,
  resolveEntryRouting,
  resolveMethodAvailability,
  resolveMobileAppPolicy,
} from './config/checkout-policy';
export {
  detectCheckoutSurface,
  isAndroidDevice,
  isPhoneDevice,
  subscribeCheckoutSurface,
} from './config/device';

export { buildPaymentQrPayload,
  renderPaymentQrSvg,
  renderBrandedPaymentQrSvg,
  renderPaymentQrMarkup,
  renderUrlQrMarkup,
  renderQrSvg,
} from './qr/render-qr';
export { openAppStore, openPaymentDeepLink, buildAndroidPaymentIntentUrl, buildPaymentDeepLinkOpenUrl } from './qr/deep-link';
export { resolveTheme, DEFAULT_THEME, applyThemeToHost } from './theme';

export type {
  PaymentSession,
  PaymentSessionPayer,
  PaymentSessionStatus,
  PaymentSessionPhase,
  ApiCheckoutMethod,
  ApiCheckoutPolicy,
  ApiMobileAppPolicy,
  BoundCheckoutPolicy,
  BindCheckoutPolicyRequest,
  StartCheckoutRequest,
  CheckoutSurface,
  VerifyPayerResponse,
  PayerPreview,
  CheckoutPolicy,
  MobileAppPolicy,
  ZippyMobileAppConfig,
  ZippyPayCheckoutInstance,
  ZippyPayConfig,
  ZippyEnvironment,
  ZippyTheme,
  CheckoutPhase,
  CheckoutMethod,
  EmbedMode,
  ProblemJson,
} from './types';

export { ZippyPayError, TERMINAL_STATUSES, POLLABLE_STATUSES } from './types';

import type { ZippyPayConfig, ZippyPayCheckoutInstance } from './types';

export const ZippyPay = {
  create(config: ZippyPayConfig): ZippyPayCheckoutInstance {
    const instance = createCheckout(config);
    if ((config.mode ?? 'inline') === 'modal') {
      instance.open();
    }
    return instance;
  },
};

defineZippyPayCheckoutElement();

export default ZippyPay;
